"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINTextInput = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var simples_1 = require("../simples");
var react_1 = require("@iconify/react");
var PINInput_1 = require("./PINInput");
var PINTextInput = /** @class */ (function (_super) {
    __extends(PINTextInput, _super);
    function PINTextInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isShown: false,
            error: null
        };
        _this.toggleVisibility = function () {
            _this.setState(function () { return ({ isShown: !_this.state.isShown }); });
        };
        _this.getValueOnChange = function (event) { return event.target.value; };
        return _this;
    }
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINTextInput' is not as... Remove this comment to see the full error message
    PINTextInput.prototype.render = function () {
        var _a = this.props, hiddenRequired = _a.hiddenRequired, error = _a.error, label = _a.label, className = _a.className, type = _a.type, secure = _a.secure, id = _a.id, validation = _a.validation, onChange = _a.onChange, onChangeForm = _a.onChangeForm, onChangeDefault = _a.onChangeDefault, t = _a.t, attr = __rest(_a, ["hiddenRequired", "error", "label", "className", "type", "secure", "id", "validation", "onChange", "onChangeForm", "onChangeDefault", "t"]);
        var finalLabel = ((attr.required && !hiddenRequired) ? "* " : "") + (label || "");
        var inputClassName = "pintextinput-input" + ((error || this.state.error) ? " error" : "");
        var secureType = this.state.isShown ? "text" : "password";
        var finalType = type || (secure ? secureType : "text");
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 's' implicitly has an 'any' type.
        var ft = t || (function (s) { return (s); });
        return (React.createElement("div", { className: "pintextinput " + (className || "") },
            React.createElement("div", { className: "pintextinput-head" },
                React.createElement("label", { className: "pintextinput-label", htmlFor: id || attr.name }, finalLabel),
                secure
                    && React.createElement(simples_1.PINButton, { inline: true, color: simples_1.PINButtonStyle.nickel, className: "pintextinput-secure-toggle", onClick: this.toggleVisibility, type: "button" },
                        React.createElement(react_1.Icon, { className: "mr-xs", icon: this.state.isShown ? "mdi:eye" : "mdi:eye-off", style: { fontSize: "2rem" } }),
                        this.state.isShown ? ft("general.hide") : ft("general.show"))),
            React.createElement("input", __assign({ type: finalType, className: inputClassName, id: id || attr.name, onChange: this.onChange }, attr)),
            (error || this.state.error)
                && React.createElement("div", { className: "pintextinput-error" }, error || this.state.error)));
    };
    PINTextInput.className = "PINTextInput";
    PINTextInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { secure: PropTypes.bool });
    return PINTextInput;
}(PINInput_1.PINInput));
exports.PINTextInput = PINTextInput;
//# sourceMappingURL=PINTextInput.js.map